/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	/**
	 * Cập nhật các thông tin liên quan tới accesstoken
	 */
	updateAccessToken: function(state, payload) {
		state.TokenType = payload.TokenType;
		state.AccessToken = payload.AccessToken;
		state.ExpiresIn = payload.ExpiresIn;
		state.AuthorizedAt = new Date();
	},

	/**
	 * Cập nhật object user info chứa thông tin user đang đăng nhập
	 * */
	updateUserInfo: function(state, data) {
		state.User = data;
	},

	/**
	 * Thực hiện đăng xuất khỏi hệ thống
	 */
	logout: function(state) {
		state.TokenType = null;
		state.AccessToken = null;
		state.ExpiresIn = null;
		state.AuthorizedAt = null;
		state.UserInfo = null;
	}
};
